export const PWA_BOOT_ERROR_CODE = 'PWA-BOOT-001'
export const PWA_BUNDLE_ERROR_CODE = 'PWA-BUNDLE-001'
export const PWA_ROUTE_ERROR_CODE = 'PWA-ROTA-001'

function escape_html(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

export function runtime_error_html(code: string, title: string, copy: string): string {
  return `
    <section class="boot-shell" data-runtime-error="${escape_html(code)}" aria-live="assertive">
      <div class="boot-card" role="alert">
        <p class="boot-eyebrow">Não foi possível abrir</p>
        <h2 class="boot-title">${escape_html(title)}</h2>
        <p class="boot-copy">${escape_html(copy)}</p>
        <p class="boot-error-code"><strong>Código: ${escape_html(code)}</strong></p>
        <button type="button" class="boot-retry" data-runtime-error-retry>Tentar novamente</button>
      </div>
    </section>`
}

export function render_runtime_error(
  container: HTMLElement,
  code: string,
  title = 'O aplicativo encontrou um erro',
  copy = 'Tente novamente. Se continuar, envie este código ao suporte.',
  report?: { phase: string; message?: unknown; stack?: unknown },
): void {
  window.__report_runtime_error?.({
    code,
    phase: report?.phase || 'runtime_error',
    message: report?.message,
    stack: report?.stack,
  })
  container.innerHTML = runtime_error_html(code, title, copy)
  container.querySelector?.<HTMLButtonElement>('[data-runtime-error-retry]')?.addEventListener('click', () => {
    window.location.reload()
  })
}
